/** Optional browsing history. Read and write only after explicit preferences consent. */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #UPDATED_KEY = 'viewedProductsUpdatedAt';
  static #MAX_PRODUCTS = 4;
  static #MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  static #currentProduct = null;

  static {
    document.addEventListener('zentrobad:privacy-change', (event) => {
      if (!event.detail.preferencesAllowed) {
        this.clearProducts();
      } else if (this.#currentProduct) {
        this.addProduct(this.#currentProduct);
      }
    });
  }

  static #allowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.currentVisitorConsent().preferences === 'yes' &&
        privacy.preferencesProcessingAllowed() === true;
    } catch {
      return false;
    }
  }

  static addProduct(productId) {
    this.#currentProduct = productId;
    if (!this.#allowed() || !productId) return;
    try {
      const products = this.getProducts().filter((id) => id !== productId);
      products.unshift(productId);
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(products.slice(0, this.#MAX_PRODUCTS)));
      localStorage.setItem(this.#UPDATED_KEY, String(Date.now()));
    } catch {
      // The shop remains usable when device storage is unavailable.
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
      localStorage.removeItem(this.#UPDATED_KEY);
    } catch {}
  }

  static getProducts() {
    if (!this.#allowed()) return [];
    try {
      const updated = Number(localStorage.getItem(this.#UPDATED_KEY));
      if (!updated || updated > Date.now() || Date.now() - updated > this.#MAX_AGE) {
        this.clearProducts();
        return [];
      }
      const products = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return Array.isArray(products) ? products.filter((id) => typeof id === 'string').slice(0, this.#MAX_PRODUCTS) : [];
    } catch {
      this.clearProducts();
      return [];
    }
  }
}
